import React from 'react';
import Box from 'sail/Box';
import Group from 'sail/Group';
import {Intro} from 'sail/Text';
import Switch from 'sail/Switch';
import {FormattedMessageOrString} from '../../../../data/localization/intlUtils';
import {useGuide} from '../../data/GuideProvider';
import Step from './Step';

const Content = ({extension, open, steps}) => {
  const {toggleExtension, setActiveStepById} = useGuide();

  return (
    <Box padding={{top: 16}} flex>
      <Group direction="vertical" spacing={{vertical: 8}}>
        <Box padding={{right: 16}}>
          <label
            style={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
            }}
          >
            <Switch
              onChange={(evt) => {
                toggleExtension(extension.id);
                if (!open) {
                  // Set the first step as active in the extension
                  // This ensures code for the step is highlighted
                  setActiveStepById(steps[0].id);
                }
              }}
              value={open}
            />
            <Intro style={{marginLeft: '12px', fontWeight: '600'}} color="dark">
              <FormattedMessageOrString
                stringOrDefineMessage={extension.heading}
              />
            </Intro>
          </label>
        </Box>

        <Intro>
          <FormattedMessageOrString stringOrDefineMessage={extension.body} />
        </Intro>
      </Group>
    </Box>
  );
};

const ExtraSteps = ({steps, open}) => {
  const classes = open ? 'ExtraSteps on' : 'ExtraSteps';
  return (
    <Group className={classes}>
      {steps.map((s, i) => (
        <Step key={`extension-step-${i}`} step={s} hidden={!open} />
      ))}
    </Group>
  );
};

/* A step that extends the integration with extra steps and code  */
export default ({extension, active, open, steps}) => {
  const {options} = useGuide();
  const filteredSteps = steps.filter(
    (step) => !step.filter || step.filter(options),
  );
  return (
    <>
      <Box padding={4} data-id={extension.id}>
        <Box padding={{bottom: open ? 0 : 16}}>
          <Content extension={extension} steps={filteredSteps} open={open} />
        </Box>
      </Box>
      <ExtraSteps steps={filteredSteps} open={open} />
    </>
  );
};
